import { Injectable } from '@angular/core';
import { ReportGroup, ReportParameter, ReportReservedParameter, Report } from '../models';

@Injectable()
export class ReportsStateService {
    groups: ReportGroup[];
    reportParameters: ReportParameter[];
    reportReservedParameters: ReportReservedParameter[];
    reportsLoading = false;
    parametersLoading = false;
    reportParameterValue: any = [];
    reportUrl = '';
    report: Report;
    clientId = '';
    parametersValid = false;
}
